import {Button} from '@/components/ui/button/Button'
import {ChevronDownIcon} from '@/components/ui/icon/Icon'
import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {makeAgendaAppointmentBackground} from '@/features/agenda/components/agenda-appointment-event/style'
import {AgendaEventStatus} from '@/features/agenda/types'
import {agendaEventStatusMapToColor, agendaEventStatusMapToDarkColor} from '@/features/agenda/utils'
import styled, {css} from 'styled-components'

export const StyledAnimatedChevron = styled(ChevronDownIcon)<{$isOpen: boolean}>(
    ({theme: {transition}, $isOpen}) => css`
        cursor: pointer;
        transition: ${transition};
        transform: ${$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    `
)

export const StyledStatusTriggerButton = styled(Button)<{$status: AgendaEventStatus; $isDisabled?: boolean}>(
    ({theme, $status, $isDisabled}) => css`
        color: ${agendaEventStatusMapToDarkColor[$status]};
        outline-color: ${agendaEventStatusMapToColor[$status]}${theme.opacities[20]};
        box-shadow: none;
        cursor: ${$isDisabled ? 'default' : 'pointer'};
        ${makeAgendaAppointmentBackground(theme)[$status]}
        &:hover {
            color: ${agendaEventStatusMapToDarkColor[$status]};
            outline-color: ${agendaEventStatusMapToColor[$status]}${theme.opacities[20]};
            ${makeAgendaAppointmentBackground(theme)[$status]}
        }

        & svg {
            color: ${agendaEventStatusMapToColor[$status]};
        }
    `
)

export const StyledMenuItem = styled(MenuItem)<{$isSelected: boolean}>(
    ({$isSelected}) => css`
        ${$isSelected
            ? css`
                  font-weight: 700;
              `
            : css`
                  font-weight: 400;
              `}
    `
)
